// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const greavard: PokeData = {
  "id": 971,
  "name": "greavard",
  "height": 6,
  "weight": 350,
  "base_experience": 58,
  "types": [
    PokeType.GHOST
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "double-edge",
    "tail-whip",
    "bite",
    "growl",
    "roar",
    "dig",
    "lick",
    "rest",
    "charm",
    "crunch",
    "helping-hand",
    "phantom-force",
    "play-rough"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "bite",
    "growl",
    "lick",
    "crunch",
    "phantom-force",
    "play-rough",
    "soul-sacrifice",
    "spectral-snatch",
    "shadow-ball",
    "spectral-chain",
    "shadow-dagger"
  ],
  "evolution_chain": {
    "id": 509,
    "item": null,
    "species": [
      {
        "name": "greavard",
        "order": 924,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "houndstone",
        "order": 925,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": 971,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 53.75,
    "speed": 34,
    "ability_power": 61
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
